
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { signIn, useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import Link from 'next/link';
import * as Yup from 'yup';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { I18n, useTranslation } from 'components/hooks/use-translation';
import GoogleBtn from 'components/atomic/atoms/google-login';
import CardLayout from 'components/layouts/card-layout';
import Button from 'components/atomic/atoms/button';
import Input from 'components/atomic/atoms/input';
import Text from 'components/atomic/atoms/text';
import Routes from 'utils/routes';
const StyledLink = styled(Text) `
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;
const initialFormValues = { email: '', password: '' };
const LoginPage = () => {
    const [loading, setLoading] = React.useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { t }: I18n = useTranslation();
    const router = useRouter();
    const session = useSession();
    const LoginSchema = React.useMemo(() => {
        return Yup.object().shape({
            password: Yup.string().trim().required(t('common:errors.requiredField')),
            email: Yup.string()
                .trim()
                .email(t('common:errors.invalidEmail'))
                .required(t('common:errors.requiredField')),
        });
    }, [t]);
    React.useEffect(() => {
        setLoading(false);
        if (session.status === 'loading')
            setLoading(true);
        if (session.status === 'authenticated')
            router.push(Routes.Home);
    }, [session, router]);
    const handleGoogleLogin = () => {
        signIn('google');
    };
    const handleSubmit = async (values: {
        email: string;
        password: string;
    }) => {
        setLoading(true);
        const res = await signIn('custom-email-password', {
            redirect: false,
            email: values.email,
            password: values.password,
            callbackUrl: (router.query.callbackUrl as string) || Routes.Home,
        });
        setLoading(false);
        if (res?.error) {
            // TODO: handle specific errors
            enqueueSnackbar(t('login:errors.generic'), { variant: 'error' });
        }
        else if (res?.url) {
            router.push(res.url);
        }
    };
    const form = useFormik({
        initialValues: initialFormValues,
        onSubmit: handleSubmit,
        validationSchema: LoginSchema,
    });
    return (<CardLayout headerType="only-logo" title={t('login:title')}>
            <Stack spacing="1rem">
                <Text variant="h4" color="primary">
                    {t('login:title')}
                </Text>
                <Text style={{ marginBottom: '1rem' }} variant="subtitle1">
                    {t('login:subtitle')}
                </Text>
                <GoogleBtn onClick={() => handleGoogleLogin()} text={t('login:buttons.googleLogin')}/>
                <Divider>
                    <Text color="text.secondary">{t('common:terms.or')}</Text>
                </Divider>
                <Input label={t('login:inputs.email')} onChange={form.handleChange('email')} value={form.values.email} error={form.touched.email ? !!form.errors.email : false} helperText={form.touched.email ? form.errors.email : undefined}/>
                <Input label={t('login:inputs.password')} type="password" onChange={form.handleChange('password')} value={form.values.password} error={form.touched.password ? !!form.errors.password : false} helperText={form.touched.password ? form.errors.password : undefined}/>
                <Stack justifyContent="flex-end" direction="row">
                    <StyledLink variant="body2" color="text.secondary">
                        <Link href={Routes.ForgotPassword}>{t('login:forgot')}</Link>
                    </StyledLink>
                </Stack>
                <Button disabled={!form.isValid} sx={{ marginTop: '1rem' }} fullWidth loading={loading} variant="contained" color="primary" endIcon={<ArrowForward />} onClick={() => form.handleSubmit()}>
                    {t('login:buttons.login')}
                </Button>
                <Stack justifyContent="center" direction="row" sx={{ marginTop: '1rem' }}>
                    <Text align="center" sx={{ marginRight: 1 }}>
                        {t('login:missingAccount')}
                    </Text>
                    <StyledLink fontWeight={600} color="primary">
                        <Link href={{
            pathname: Routes.SignUp,
            query: router.query,
        }}>
                            {t('login:signup')}
                        </Link>
                    </StyledLink>
                </Stack>
            </Stack>
        </CardLayout>);
};
export default LoginPage;

    async function __Next_Translate__getStaticProps__18916ceb1a9__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/login',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb1a9__ as getStaticProps }
  